import React, { useMemo } from 'react';
import Title from '../../Title';
import Menu from '../../../components/Menu';
import { useHistory } from 'react-router-dom';
import {
    doubleColumnGrid,
    singleColumnGrid,
    tabsData,
    URL_MAIN_INFO,
    URL_TAB_PARAM,
} from '../../../../../utils/property/propertyUtils';
import Card from '../../../../../muiComponents/Card';
import StarRating from './StarRating';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../contextsProperty/ContextProperties';
import Grid from '../../../../../muiComponents/Grid';
import GridChild from '../../../../../muiComponents/GridChild';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import LabelAndContentBlock from '../../LabelAndContentBlock';
import useUserProfile from '../../../../../customHooks/useUserProfile';
import { isTodayInPeriod } from '../../../../../utils/formatDates';
import { useAppConfigurationSections } from '../../../../../contexts/AppConfigurationContext';
import { AppSectionsCore } from '../../../../../types/appConfiguration/appConfigTypes';
import Tooltip from '../../../../../muiComponents/Tooltip';
import Tag from '../../../../../muiComponents/Tag';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import useTranslate from '../../../../../customHooks/useTranslate';
import {
    gridSpacing30,
    gridSpacing40,
} from '../../../../../utils/commonVariables/grid';

const MainInfoSection = () => {
    const history = useHistory();
    const path = history.location.pathname;

    const { name, hotelCategory, rating, address, email, phone, stopSales } =
        usePropertyPresentation();
    const translate = useTranslate();
    const { isFetching } = usePropertyFetching();
    const { readOnlyUser } = useUserProfile();
    const { core } = useAppConfigurationSections();

    const scrollToSection = (idSection: string) => {
        document
            .getElementById(idSection)
            ?.scrollIntoView({ behavior: 'smooth' });
    };

    const hotelStopSales = useMemo(() => {
        return stopSales.find(stopSale => {
            const isHotelStopSale =
                !stopSale.idRoom &&
                !stopSale.idRatePlan &&
                !stopSale.idMealPlan;
            const isEnabledStopSale = stopSale.enabled;
            const isCurrentStopSale = isTodayInPeriod(
                stopSale.fromDate,
                stopSale.toDate
            );
            return isHotelStopSale && isEnabledStopSale && isCurrentStopSale;
        });
    }, [stopSales]);

    return (
        <section className='flex-column gap-5'>
            {isFetching ? (
                <LoadingPlaceholder variant='text' height={40} />
            ) : (
                <div className='flex flex-between  flex-align-center'>
                    <Title text='main_info' />
                    <div className='flex flex-align-center gap-10'>
                        {core.pages[AppSectionsCore.STOP_SALES] &&
                        hotelStopSales ? (
                            <Tooltip
                                titleText={'go_to_property_stop_sales_section'}
                            >
                                <span>
                                    <Tag
                                        text={translate(
                                            'property_stop_sales_active'
                                        )}
                                        variant='contrast'
                                        color='red'
                                        style={{
                                            gap: '5px',
                                            cursor: 'pointer',
                                        }}
                                        startIcon={commonIcons.STOP_SALE}
                                        onClick={(
                                            e: React.MouseEvent<HTMLDivElement>
                                        ) => {
                                            e.stopPropagation();
                                            scrollToSection('stop_sales');
                                        }}
                                    />
                                </span>
                            </Tooltip>
                        ) : (
                            ''
                        )}
                        {readOnlyUser ? (
                            ''
                        ) : (
                            <Menu
                                menuItems={[
                                    {
                                        text: 'edit',
                                        icon: 'Edit',
                                        onClick: () => {
                                            const tab =
                                                tabsData.main_info.tabs[0]
                                                    .tabNumber;

                                            history.push(
                                                `${path}${URL_MAIN_INFO}${URL_TAB_PARAM(
                                                    tab
                                                )}`
                                            );
                                        },
                                    },
                                ]}
                            />
                        )}
                    </div>
                </div>
            )}

            <Card className='padding20 flex-column gap-20'>
                <div>
                    {isFetching ? (
                        <LoadingPlaceholder variant='text' height={20} />
                    ) : (
                        <>
                            <Title
                                text={name}
                                translated={false}
                                className='text-secondary-color'
                            />
                            <StarRating rating={rating} title={hotelCategory} />
                        </>
                    )}
                </div>
                <Grid columnSpacing={gridSpacing30} rowSpacing={gridSpacing40}>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LabelAndContentBlock
                            label='address'
                            content={address}
                            loading={isFetching}
                        />
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <LabelAndContentBlock
                            label='email2'
                            content={email}
                            loading={isFetching}
                        />
                    </GridChild>
                    <GridChild gridProps={singleColumnGrid}>
                        <LabelAndContentBlock
                            label='phone'
                            content={phone}
                            loading={isFetching}
                        />
                    </GridChild>
                </Grid>
            </Card>
        </section>
    );
};

export default MainInfoSection;
